const TIME_FORMAT = 'hh:m a';
const DATE_FORMAT = 'MMM, dd yyyy';
const FULL_DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm:ss zzz';
const FULL_DATE_TIME_FORMAT_ISO_Z = "yyyy-MM-dd'T'HH:mm:ss.SSSX";
const FULL_DATE_TIME_FORMAT2 = 'MMMM d yyyy, h:mm aa';
const CALENDAR_DATE_TIME_FORMAT = 'MMMM d, yyyy h:mm aa';
export const MS_IN_SECOND = 1000;
export const MS_IN_TEN_SECONDS = MS_IN_SECOND * 10;
export const MS_IN_MINUTE = MS_IN_SECOND * 60;
export const MS_IN_HOUR = MS_IN_MINUTE * 60;
export const MS_IN_DAY = MS_IN_HOUR * 24;

export const dateConst = {
	TIME_FORMAT,
	DATE_FORMAT,
	FULL_DATE_TIME_FORMAT,
	FULL_DATE_TIME_FORMAT_ISO_Z,
	FULL_DATE_TIME_FORMAT2,
	CALENDAR_DATE_TIME_FORMAT,
};

export const baseApiHeaders = {
	'x-breet-env': import.meta.env.VITE_BREET_ENV,
};

export const HIDE_TOAST_KEY = 'x-hide-toast';

export const KYBSTATUSES = {
	COMPLETED: 'completed',
	REJECTED: 'rejected',
	PARTIAL: 'partial',
	PENDING: 'pending',
} as const;

export const CURRENCYCONFIG = {
	NGN: { country: 'Nigeria', locale: 'en-NG', symbol: '₦', currency: 'nigerian naira', currencyShort: 'naira', code: 'NGN' },
	GHS: { country: 'Ghana', locale: 'en-GH', symbol: '₵', currency: 'ghanaian cedi', currencyShort: 'cedi', code: 'GHS' },
	USD: {
		country: 'United States of America',
		locale: 'en-US',
		symbol: '$',
		currency: 'us dollar',
		currencyShort: 'dollar',
		code: 'USD',
	},
} as const;

export const CURRENCIES: CURRENCYCODETYPE[] = Object.values(CURRENCYCONFIG).map((config) => config.code);

export type CURRENCYCONFIGTYPE = (typeof CURRENCYCONFIG)[keyof typeof CURRENCYCONFIG];

export type CURRENCYCODETYPE = keyof typeof CURRENCYCONFIG;

export type CURRENCYSYMBOLTYPE = (typeof CURRENCYCONFIG)[keyof typeof CURRENCYCONFIG]['symbol'];

export type CURRENCYNAMETYPE = (typeof CURRENCYCONFIG)[keyof typeof CURRENCYCONFIG]['currency'];

export type COUNTRYTYPE = (typeof CURRENCYCONFIG)[keyof typeof CURRENCYCONFIG]['country'];

export type LOCALETYPE = (typeof CURRENCYCONFIG)[keyof typeof CURRENCYCONFIG]['locale'];

export type CURRENCYSHORTTYPE = (typeof CURRENCYCONFIG)[keyof typeof CURRENCYCONFIG]['currencyShort'];

export const SORT_LATEST_TO_OLDEST = -1;
export const SORT_OLDEST_TO_LATEST = 1;

export const INACTIVITY_TOTAL_DURATION = 5 * 60 * 1000;
export const INACTIVITY_WARNING_OFFSET = 1 * 60 * 1000;

export const ISPRODUCTION = typeof window !== 'undefined' ? window.location.origin === 'https://partners.breet.io' : false;

export type MENUICONTYPE =
	| 'home'
	| 'asset'
	| 'transaction'
	| 'wallet'
	| 'analytics'
	| 'settings'
	| 'logout'
	| 'sub-accounts'
	| 'developer';
export type MENUTTITLEYPE =
	| 'Home'
	| 'Assets'
	| 'Transactions'
	| 'Wallet'
	| 'Analytics'
	| 'Developer'
	| 'Settings'
	| 'Log Out'
	| 'Sub-Accounts'
	| 'Notifications';

export const POSTMAN_DOCUMENTATION = 'https://docs.breet.io/';

export const FXRATE = {
	DEFAULT: 'default',
	BUY: 'buy',
} as const;

export const FXCONVERSION = {
	NGNToGHS: 'NGNToGHS',
	GHSToNGN: 'GHSToNGN',
	SELLUSD: 'SellUSD',
	FIATToUSD: 'FiatToUSD',
} as const;

export const OTPLENGTH = 6;
export const PINLENGTH = 4;

export const TWOFAWARNINGTHRESHOLD = {
	NGN: 20000000,
	GHS: 100000,
	USD: 10000,
};

export const HTTPERROR = {
	EMAIL: 'please enter email otp',
	AUTHENTICATOR: 'please enter authenticator otp',
	OTPSENT: 'OTP authentication details sent to the associated email',
	RESETLINKEXPIRED: 'reset link is invalid or has expired. Please request a new one.',
};

export const HTTPSTATUSCODE = {
	TWOFA: 202,
	NEWDEVICE: 206,
	TRANSACTIONNOAUTH: 403,
};

export const FIXEDCACHEKEYS = {
	SAVE_WALLET_ADDRESS: 'saveWalletAddress',
} as const;
